import { NgIf } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import Hls from 'hls.js';

@Component({
    selector: 'app-content-player',
    templateUrl: './content.player.component.html',
    styleUrls: ['./content.player.component.scss'],
    imports: [NgIf],
    standalone: true,
})
export class ContentPlayerComponent implements AfterViewInit {
    @Input() src?: string;
    @ViewChild('video') videoRef!: ElementRef<HTMLVideoElement>;

    @Input() image?: string;
    isPlaying = false;
    isMuted = false;
    progress = 0;
    isLoading = true;

    private hls?: Hls;

    ngAfterViewInit() {
        const video = this.videoRef?.nativeElement;

        if (!video) return;

        if (this.src.endsWith('.m3u8')) {
            if (Hls.isSupported()) {
                this.hls = new Hls({
                    autoStartLoad: true,
                    startLevel: 0,
                    lowLatencyMode: true,
                });
                this.hls.loadSource(this.src);
                this.hls.attachMedia(video);
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = this.src;
            }
        } else {
            video.src = this.src;
        }

        video.autoplay = true;
        video.play().catch(err => {
            console.warn('Autoplay failed, waiting for user interaction:', err);
        });

        video.addEventListener('waiting', () => (this.isLoading = true));
        video.addEventListener('playing', () => (this.isLoading = false));
        video.addEventListener('canplay', () => (this.isLoading = false));

        video.addEventListener('timeupdate', () => {
            if (video.duration) {
                this.progress = (video.currentTime / video.duration) * 100;
            }
        });

        video.addEventListener('play', () => (this.isPlaying = true));
        video.addEventListener('pause', () => (this.isPlaying = false));
    }



    async togglePlay() {
        const video = this.videoRef.nativeElement;
        if (this.isPlaying) {
            video.pause();
        } else {
            this.isLoading = true;
            try {
                await video.play();
            } catch (err) {
                console.warn('Play error:', err);
            }
        }
    }

    toggleMute() {
        const video = this.videoRef.nativeElement;
        this.isMuted = !this.isMuted;
        video.muted = this.isMuted;
    }

    seek(event: Event) {
        const input = event.target as HTMLInputElement;
        const video = this.videoRef.nativeElement;
        const time = (parseFloat(input.value) / 100) * video.duration;
        video.currentTime = time;
    }

    async goFullscreen() {
        const video = this.videoRef.nativeElement;
        if (video.requestFullscreen) {
            await video.requestFullscreen();
        }
    }
}
